/* global angular */

require('./tips-rotator.component.css')
require('angular-animate')
require('angular-sanitize')

/*
  This component makes tips placed in blue bubble interactive. On mouse over, this component shows left and right handle
  to navigate through the tips, that are provided as the input. Clicking on the tip or right handle shows the next tip,
  clicking on the left handle shows the previous one. Animations are used to create fade-out + fade-in effects.
 */
angular.module('TipsRotatorCmp', ['ngAnimate', 'ngSanitize'])
  .component('tipsRotator', {
    template: require('./tips-rotator.component.tpl.html'),
    controller: TipsRotatorCtrl,
    controllerAs: 'vm',
    bindings: {
      tips: '<',
      label: '<',
      inputClass: '<'
    }
  })

  // directive not defined independently in the directives folder, because it's specific to this component
  .directive('fadeOutFadeIn', ['$timeout', function ($timeout) {
    return function (scope, element, attr) {
      scope.$watch(attr.fadeOutFadeIn, function (newValue, oldValue) {
        if (newValue !== oldValue) {
          element.addClass('fading')
          $timeout(function () {
            element.removeClass('fading')
          }, 750) // needs to be at least 600, anything greater than 600 adds time between fade-out and fade-in
        }
      })
    }
  }])

TipsRotatorCtrl.$inject = ['$scope']

function TipsRotatorCtrl ($scope) {
  var vm = this

  vm.$onInit = function () {
    // indicates if the mouse cursor is over the component
    vm.hovered = false
    // identifies selected tip in the vm.tips array
    vm.tipIndex = 0
    /* text to be shown in the tip bubble, this variable would be redundant, but it serves as workaround to keep old
       value in the bubble when the fade-out animation started */
    vm.label = vm.label || 'TIP'
    vm.label += ':'
    if (vm.tips && vm.tips instanceof Array) {
      vm.tip = vm.tips[0]
    }
  }

  vm.onMouseEnter = function () {
    vm.hovered = true
  }

  vm.onMouseLeave = function () {
    vm.hovered = false
  }

  vm.showPrevious = function () {
    if (--vm.tipIndex < 0) {
      vm.tipIndex = vm.tips.length - 1
    }
    setTimeout(vm.updateTip, 600)
  }

  vm.showNext = function () {
    if (++vm.tipIndex >= vm.tips.length) {
      vm.tipIndex = 0
    }
    setTimeout(vm.updateTip, 600)
  }

  vm.updateTip = function () {
    vm.tip = vm.tips[vm.tipIndex]
  }

  $scope.$watch(function (scope) { return scope.vm.tips },
    function (newValue, oldValue) {
      vm.updateTip()
    }, true
  )
}
